import { MessageRelayTypes } from 'calling-cross-tab-library/types/MessageRelayTypes';
import { UUID } from 'shared-worker-versioning/lib/utils/UUID';
export const createBroadcastMessage = ({
  payload,
  type,
  destinationConnectionId
}) => {
  return {
    id: UUID(),
    type,
    payload,
    metadata: {
      messageRelayType: MessageRelayTypes.BROADCAST
    },
    destinationConnectionId
  };
};
export const createChannelBroadcastMessage = ({
  payload,
  type,
  destinationConnectionId,
  originConnectionId,
  messageRelayChannel
}) => {
  return {
    id: UUID(),
    type,
    payload,
    metadata: {
      messageRelayType: MessageRelayTypes.BROADCAST,
      messageRelayChannel
    },
    destinationConnectionId,
    originConnectionId
  };
};